import axios from 'axios';

const aclInstance = axios.create({
	baseURL: process.env.ACL_URL,
});

const middlewareInstance = axios.create({
	baseURL: process.env.MIDDLEWARE_URL,
});

const productionInstance = axios.create({
	baseURL: process.env.PRODUCTION_URL,
});

const productsInstance = axios.create({
	baseURL: process.env.PRODUCTS_URL,
});

const productsReadInstance = axios.create({
	baseURL: process.env.PRODUCTS_READ_URL,
});

const salesInstance = axios.create({
	baseURL: process.env.SALES_URL,
});

const salesReadInstance = axios.create({
	baseURL: process.env.SALES_READ_URL,
});

const sunatInstance = axios.create({
	baseURL: process.env.SUNAT,
});

const facturacionInstance = axios.create({
	baseURL: process.env.FACTURACION_SUNAT_URL,
});

const quipuInstance = axios.create({
	baseURL: process.env.API_PRODUCTS,
});

const motorInstance = axios.create({
	baseURL: process.env.API_QUIPU,
});

const accountInstance = axios.create({
	baseURL: process.env.API_ACCOUNT,
});

const fakeInstance = axios.create({
	baseURL: 'https://reqres.in/api',
});

const reportsInstance = axios.create({
	baseURL: process.env.API_REPORTS,
});

// const googleInstance = axios.create({
// 	baseURL: process.env.GOOGLE_SEARCH_PLACE,
// });
const excelApiService = axios.create({
	baseURL: process.env.API_EXCEL,
});

export default function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$http = productsInstance;
	Vue.prototype.$httpProductsRead = productsReadInstance;
	Vue.prototype.$httpAcl = aclInstance;
	Vue.prototype.$httpMiddleware = middlewareInstance;
	Vue.prototype.$httpProduction = productionInstance;
	Vue.prototype.$httpSales = salesInstance;
	Vue.prototype.$httpSalesRead = salesReadInstance;
	Vue.prototype.$httpSunat = sunatInstance;
	Vue.prototype.$httpFacSunat = facturacionInstance;
	Vue.prototype.$httpProducts = quipuInstance;
	Vue.prototype.$httpQuipu = motorInstance;
	Vue.prototype.$httpAccount = accountInstance;
	Vue.prototype.$httpFake = fakeInstance;
	Vue.prototype.$httpReports = reportsInstance;
	// Vue.prototype.$httpSearchGoogle = googleInstance;
	Vue.prototype.$httpExcelApiService = excelApiService;
}



// WEBPACK FOOTER //
// ./src/axios.js